import { supabase } from '@/lib/supabase/supabaseClient';
import { GetAllSurveyBankTemplatesProps } from '.';
import { groupQuestionsByDependencies } from '@/features/question/hooks/useQuery/useGetQuestionsBySurveyId/utils/groupQuestionsByDependencies';

export const getAllSurveyBankTemplates = async ({
  whereCrmSystems = [],
  orgId,
}: GetAllSurveyBankTemplatesProps) => {
  return await supabase
    .from('survey_bank')
    .select(
      `
        *,
        author:user(*),
        survey_bank_question_bank(*)
    `
    )
    .filter('crm_system', 'in', `(${whereCrmSystems.join(',')})`)
    .eq(`organisation_id`, orgId)
    .throwOnError()
    .then((res) => res.data)
    .then((res) =>
      res?.map((res) => ({
        ...res,
        grouped_questions: groupQuestionsByDependencies(
          res.survey_bank_question_bank
        ),
      }))
    );
};
